const message = {
  "tip": {
    "群成员": "群成員",
    "加入群组": "加入群組",
    "退出群组": "退出群組",
    "被": "被",
    "踢出群组": "踢出群組",
    "成为管理员": "成為管理員",
    "被撤销管理员": "被撤銷管理員",
    "被禁言": "被禁言",
    "被取消禁言": "被取消禁言",
    "群提示消息": "群提示消息",
    "管理员": "管理員",
    "开启全员禁言": "開啟全員禁言",
    "取消全员禁言": "取消全員禁言",
    "成为新的群主": "成為新的群主",
    "修改群名为": "修改群名為",
    "发布新公告": "發布新公告",
    "把群公告修改为": "把群公告修改為",
    "申请加入群组": "申請加入群組",
    "成功加入群组": "成功加入群組",
    "被拒绝": "被拒絕",
    "你被管理员": "你被管理員",
    "群": "群",
    "解散": "解散",
    "创建群": "創建群",
    "邀请你加群": "邀請你加群",
    "你退出群组": "你退出群組",
    "你被": "你被",
    "设置为群": "設置為群",
    "的管理员": "的管理員",
    "撤销群": "撤銷群",
    "的管理员身份": "的管理員身份",
    "同意加群": "同意加群",
    "拒接加群": "拒接加群",
    "自定义群系统通知": "自定義群系統通知"
  },
  "custom": {
    "自定义消息": "自定義消息",
    "通话时长": "通話時長",
    "通话结束": "通話結束",
    "切换语音通话": "切換語音通話",
    "切换视频通话": "切換視頻通話",
    "发起通话": "發起通話",
    "取消通话": "取消通話",
    "已接听": "已接聽",
    "拒绝通话": "拒絕通話",
    "无应答": "無應答",
    "对本次服务评价": "對本次服務評價",
    "查看详情>>": "查看詳情>>",
    "已取消": "已取消",
    "对方已取消": "對方已取消",
    "已拒绝": "已拒絕",
    "对方已拒绝": "對方已拒絕",
    "对方忙线中": "對方忙線中",
    "忙线未接听": "忙線未接聽",
    "对方无应答": "對方無應答",
    "超时无应答": "超時無應答",
  }
}

export default message;
